import { Component } from '@angular/core'

@Component({
  selector: 'kdgh-not-found-route',
  templateUrl: './not-found-route.component.html',
  styleUrls: ['./not-found-route.component.scss'],
})
export class NotFoundRouteComponent {}
